/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// This file has been customised for the purposes of the VHIL project.
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/common/Accordion/Accordion';
import AccordionItem from '../components/common/Accordion/AccordionItem';
import AccordionReusable from '../components/common/AccordionReusable';
import Alert from '../components/common/Alert';
import ApplySummary from '../components/common/ApplySummary';
import Banner from '../components/common/Banner';
import BrandAssurance from '../components/common/BrandAssurance/BrandAssurance';
import BrandAssuranceImage from '../components/common/BrandAssurance/BrandAssuranceImage';
import Carousel from '../components/common/Carousel/Carousel';
import CarouselItem from '../components/common/Carousel/CarouselItem';
import Checklist from '../components/common/Checklist/Checklist';
import ChecklistItem from '../components/common/Checklist/ChecklistItem';
import ConditionalRichText from '../components/common/ConditionalRichText';
import Container from '../components/common/Container';
import ContentBlock from '../components/common/ContentBlock';
import ContentSlotCard from '../components/common/ContentSlotCard';
import CrossSellBar from '../components/common/CrossSellBar';
import ErrorMessage from '../components/common/ErrorMessage';
import Footer from '../components/common/Footer';
import FormGroup from '../components/common/FormGroup';
import FormPageInner from '../components/common/FormPageInner';
import GlobalNavigation from '../components/common/GlobalNavigation';
import HorizontalCard from '../components/common/HorizontalCard';
import IconList from '../components/common/IconList/IconList';
import IconListItem from '../components/common/IconList/IconListItem';
import InterstitialHeader from '../components/common/InterstitialHeader';
import Link from '../components/common/Link';
import ListIconItem from '../components/common/ListIconItem';
import Modal from '../components/common/Modal';
import Notification from '../components/common/Notification';
import ProgressBar from '../components/common/ProgressBar';
import QuoteSummary from '../components/common/QuoteSummary';
import QuoteSummaryDetails from '../components/common/QuoteSummaryDetails';
import QuoteSummaryHero from '../components/common/QuoteSummaryHero';
import RichText from '../components/common/RichText';
import Section from '../components/common/Section';
import SectionHeading from '../components/common/SectionHeading';
import SitecorePersonalizationTracker from '../components/common/SitecorePersonalizationTracker';
import StaticDOB from '../components/common/StaticDOB';
import StaticPostcode from '../components/common/StaticPostcode';
import SuperHero from '../components/common/SuperHero';
import Tooltip from '../components/common/Tooltip';
import UnorderedList from '../components/common/UnorderedList/UnorderedList';
import UnorderedListItem from '../components/common/UnorderedList/UnorderedListItem';
import WideCard from '../components/common/WideCard';
import ConfirmationPage from '../components/layouts/ConfirmationPage';
import FormPage from '../components/layouts/FormPage';
import QuoteSummaryPage from '../components/layouts/QuoteSummaryPage';
import VdsContentPage from '../components/layouts/VdsContentPage';
import BankDetailsLogic from '../components/logic/BankDetailsLogic';
import ConfirmChildDetailsLogic from '../components/logic/ConfirmChildDetailsLogic';
import ConfirmDetailsLogic from '../components/logic/ConfirmDetailsLogic';
import ConfirmPartnerDetailsLogic from '../components/logic/ConfirmPartnerDetailsLogic';
import DatalayerPush from '../components/logic/DatalayerPush';
import DependentsLogic from '../components/logic/DependentsLogic';
import DirectDebitMandateLogic from '../components/logic/DirectDebitMandateLogic';
import EmailRetrieveQuote from '../components/logic/EmailRetrieveQuote';
import GetQuoteLogic from '../components/logic/GetQuoteLogic';
import HealthDeclarationLogic from '../components/logic/HealthDeclarationLogic';
import NumberOfChildrenLogic from '../components/logic/NumberOfChildrenLogic';
import PartnerDetailsLogic from '../components/logic/PartnerDetailsLogic';
import PartnerOrChildrenLogic from '../components/logic/PartnerOrChildrenLogic';
import QuoteApplyLogic from '../components/logic/QuoteApplyLogic';
import RetrieveQuoteLogic from '../components/logic/RetrieveQuoteLogic';
import WhoToCoverLogic from '../components/logic/WhoToCoverLogic';
import Callback from '../components/overlays/Callback';
import InterstitialPage from '../components/overlays/InterstitialPage';
import RetrieveQuote from '../components/overlays/RetrieveQuote';
import SessionTimeout from '../components/overlays/SessionTimeout';
import Utms from '../components/overlays/Utms';
import AddressPicker from '../components/questions/AddressPicker';
import CheckboxQuestion from '../components/questions/Checkbox/CheckboxQuestion';
import CheckboxQuestionItem from '../components/questions/Checkbox/CheckboxQuestionItem';
import ChildrenChecklist from '../components/questions/ChildrenChecklist';
import DatePicker from '../components/questions/DatePicker';
import DateQuestion from '../components/questions/DateQuestion';
import DirectDebitQuestion from '../components/questions/DirectDebitQuestion';
import InputQuestion from '../components/questions/InputQuestion';
import NumberPicker from '../components/questions/NumberPicker';
import PaymentDayDropDown from '../components/questions/PaymentDayDropDown';
import PostcodeQuestion from '../components/questions/PostcodeQuestion';
import RadioQuestion from '../components/questions/Radio/RadioQuestion';
import RadioQuestionItem from '../components/questions/Radio/RadioQuestionItem';
import SubmitButton from '../components/questions/SubmitButton';
import TitleQuestion from '../components/questions/TitleQuestion';

const components = new Map();
components.set('Accordion', Accordion);
components.set('AccordionItem', AccordionItem);
components.set('AccordionReusable', AccordionReusable);
components.set('Alert', Alert);
components.set('ApplySummary', ApplySummary);
components.set('Banner', Banner);
components.set('BrandAssurance', BrandAssurance);
components.set('BrandAssuranceImage', BrandAssuranceImage);
components.set('Carousel', Carousel);
components.set('CarouselItem', CarouselItem);
components.set('Checklist', Checklist);
components.set('ChecklistItem', ChecklistItem);
components.set('ConditionalRichText', ConditionalRichText);
components.set('Container', Container);
components.set('ContentBlock', ContentBlock);
components.set('ContentSlotCard', ContentSlotCard);
components.set('CrossSellBar', CrossSellBar);
components.set('ErrorMessage', ErrorMessage);
components.set('Footer', Footer);
components.set('FormGroup', FormGroup);
components.set('FormPageInner', FormPageInner);
components.set('GlobalNavigation', GlobalNavigation);
components.set('HorizontalCard', HorizontalCard);
components.set('IconList', IconList);
components.set('IconListItem', IconListItem);
components.set('InterstitialHeader', InterstitialHeader);
components.set('Link', Link);
components.set('ListIconItem', ListIconItem);
components.set('Modal', Modal);
components.set('Notification', Notification);
components.set('ProgressBar', ProgressBar);
components.set('QuoteSummary', QuoteSummary);
components.set('QuoteSummaryDetails', QuoteSummaryDetails);
components.set('QuoteSummaryHero', QuoteSummaryHero);
components.set('RichText', RichText);
components.set('Section', Section);
components.set('SectionHeading', SectionHeading);
components.set('SitecorePersonalizationTracker', SitecorePersonalizationTracker);
components.set('StaticDOB', StaticDOB);
components.set('StaticPostcode', StaticPostcode);
components.set('SuperHero', SuperHero);
components.set('Tooltip', Tooltip);
components.set('UnorderedList', UnorderedList);
components.set('UnorderedListItem', UnorderedListItem);
components.set('WideCard', WideCard);
components.set('ConfirmationPage', ConfirmationPage);
components.set('FormPage', FormPage);
components.set('QuoteSummaryPage', QuoteSummaryPage);
components.set('VdsContentPage', VdsContentPage);
components.set('BankDetailsLogic', BankDetailsLogic);
components.set('ConfirmChildDetailsLogic', ConfirmChildDetailsLogic);
components.set('ConfirmDetailsLogic', ConfirmDetailsLogic);
components.set('ConfirmPartnerDetailsLogic', ConfirmPartnerDetailsLogic);
components.set('DatalayerPush', DatalayerPush);
components.set('DependentsLogic', DependentsLogic);
components.set('DirectDebitMandateLogic', DirectDebitMandateLogic);
components.set('EmailRetrieveQuote', EmailRetrieveQuote);
components.set('GetQuoteLogic', GetQuoteLogic);
components.set('HealthDeclarationLogic', HealthDeclarationLogic);
components.set('NumberOfChildrenLogic', NumberOfChildrenLogic);
components.set('PartnerDetailsLogic', PartnerDetailsLogic);
components.set('PartnerOrChildrenLogic', PartnerOrChildrenLogic);
components.set('QuoteApplyLogic', QuoteApplyLogic);
components.set('RetrieveQuoteLogic', RetrieveQuoteLogic);
components.set('WhoToCoverLogic', WhoToCoverLogic);
components.set('Callback', Callback);
components.set('InterstitialPage', InterstitialPage);
components.set('RetrieveQuote', RetrieveQuote);
components.set('SessionTimeout', SessionTimeout);
components.set('Utms', Utms);
components.set('AddressPicker', AddressPicker);
components.set('CheckboxQuestion', CheckboxQuestion);
components.set('CheckboxQuestionItem', CheckboxQuestionItem);
components.set('ChildrenChecklist', ChildrenChecklist);
components.set('DatePicker', DatePicker);
components.set('DateQuestion', DateQuestion);
components.set('DirectDebitQuestion', DirectDebitQuestion);
components.set('InputQuestion', InputQuestion);
components.set('NumberPicker', NumberPicker);
components.set('PaymentDayDropDown', PaymentDayDropDown);
components.set('PostcodeQuestion', PostcodeQuestion);
components.set('RadioQuestion', RadioQuestion);
components.set('RadioQuestionItem', RadioQuestionItem);
components.set('SubmitButton', SubmitButton);
components.set('TitleQuestion', TitleQuestion);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
